import { Box, colors } from '@factorialco/deprecated-design-system'
import { AxisProps } from '@nivo/axes'
import { ResponsiveBar } from '@nivo/bar'

import Legend from 'modules/project_management/components/charts/Legend'

import skeletonData from './timeSkeletonData.json'

const DetailGraphLoadingSkeleton = ({
  axisBottom,
  axisLeft,
}: {
  axisBottom: AxisProps
  axisLeft: AxisProps
}) => (
  <Box width="full" gap="s12">
    <Box height="s300" width="full">
      <ResponsiveBar
        data={skeletonData.data}
        keys={skeletonData.keys}
        indexBy="label"
        margin={{ left: 68, top: 10, bottom: 34, right: 50 }}
        padding={0.5}
        enableGridX={false}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={() => String(colors.grey300)}
        axisTop={null}
        axisRight={null}
        axisBottom={axisBottom}
        axisLeft={axisLeft}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
          from: 'color',
        }}
        enableLabel={false}
      />
    </Box>
    <Legend items={[{ id: '1', label: 'data', color: 'grey400' }]} />
  </Box>
)

export default DetailGraphLoadingSkeleton
